import React, { useState, useEffect } from "react";
import SponsorModal from "../../Components/layouts/dashboard/SponsorModal";
// import DashboardAnswer from "../../Components/layouts/Message/DashboardAnswer";
// import DashboardSendMessage from "../../Components/layouts/Message/DashboardSendMessage";
// import DashboarMessageTable from "../../Components/layouts/Message/DashboarMessageTable";
// import MessageModal from "../../Components/layouts/Message/MessageModal";
// import AddnewsupportTicket from "../../Components/layouts/SupportTicket/AddnewsupportTicket";
// import SupportTicketanswer from "../../Components/layouts/SupportTicket/SupportTicketanswer";
// import SupportTicketTable from "../../Components/layouts/SupportTicket/SupportTicketTable";
import { BtnPrimary } from "../../Components/share/buttons/Btn";
import { Modal } from "../../Components/share/modal/Modal";
import { ReactComponent as Trash } from "../../Assets/Image/svg/trash.svg";
import { ReactComponent as Edit } from "../../Assets/Image/svg/edit.svg";
import Card from "../../Components/share/cards/Card";
import IconButton from "../../Components/share/buttons/IconButton";
import AdminPagination from "../../Components/share/Pageination/AdminPagination";
import Cookies from "js-cookie";
import useFetch from "../../Hooks/useFetch";
import { current } from "daisyui/src/colors";
import MainPagination from "../../Components/share/Pageination/MainPagination";

const Message = ({ setTicketAnswer }) => {
    const [newMessage, setNewMessage] = useState(false);
    const [Answer, setAnswer] = useState(false);
    const [organizer, setOrganizer] = useState();
    const [organizerDel, setOrganizerDel] = useState();
    const [edit, setEdit] = useState();
    const [editIdOrganize, setEditIdOrganize] = useState();
    const [pagination, setPagination] = useState({
        current: 1,
    });

    const getOrganizer = useFetch({
        method: "GET",
        url: `OrganizerService/organizers`,
        pagination: pagination,
        noHeader: false,
        trigger: true,
        setter: setOrganizer,
    });

    const deleteOrganizer = useFetch({
        method: "DELETE",
        url: `OrganizerService/${organizerDel}`,
        noHeader: false,
        caller: getOrganizer,
    });

    const showAnswer = () => {
        setAnswer(true);
    };

    const handleDeleteOrganizer = (id) => {
        setOrganizerDel(id);
        deleteOrganizer.reFetch();
    };

    const handleEditOrganizer = (id) => {
        setEdit(true);
        setEditIdOrganize(id);
    };

    useEffect(() => {
        getOrganizer.reFetch();
    }, [pagination]);

    return (
        <div className="SupportTicket">
            <div className=" flex SupportTicket__header justify-between items-center px-24 pt-24">
                <h3>اطلاعات برگزارکنندگان بوت کمپ</h3>
                <BtnPrimary
                    text="+افزودن برگزارکننده"
                    className=" px-12 py-8 mt-6 mb-8"
                    onClick={() => setNewMessage(!newMessage)}
                />
            </div>
            <div className="mx-24 py-24">
                <Card className="grid grid-cols-5 gap-[40px] px-[15px] py-[30px] SupportTicketTable-header bg-[rgba(156,95,164,0.4)] ">
                    <div>لوگو</div>
                    <div>نام</div>
                    <div>سمت</div>
                    <div>وب‌سایت</div>
                </Card>
                {organizer &&
                    organizer?.results.map((i) => (
                        <Card
                            // key={i.id}
                            className="grid grid-cols-5 gap-[40px] px-[15px] py-[15px] SupportTicketTable-body  my-4"
                        >
                            <div className="SupportTicketTable-body-name flex justify-center items-center">
                                <img
                                    className="w-1/3"
                                    src={i.organizer_avatar}
                                    alt=""
                                />
                            </div>
                            <div className="flex justify-center items-center">
                                {i.organizer_name}
                            </div>
                            <div className="flex justify-center items-center">
                                <p className="">
                                    {i.organizer_name && "برگزار کننده"}
                                </p>
                            </div>
                            <div className="flex justify-center items-center">
                                <a
                                    className="text-purple"
                                    href={`//${i.organizer_website}`}
                                    target="_blank"
                                    // rel="noreferrer"
                                >
                                    {i.organizer_website}
                                </a>
                            </div>
                            <div className="flex justify-center items-center">
                                <div className="flex">
                                    <div
                                        onClick={() =>
                                            handleDeleteOrganizer(i.id)
                                        }
                                    >
                                        <IconButton data-tip="حذف">
                                            <Trash />
                                        </IconButton>
                                    </div>
                                    <div
                                        onClick={() =>
                                            handleEditOrganizer(i.id)
                                        }
                                    >
                                        <IconButton data-tip="ویرایش">
                                            <Edit />
                                        </IconButton>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    ))}
                <Modal show={newMessage}>
                    <SponsorModal
                        getOrganizer={getOrganizer}
                        close={setNewMessage}
                        method="POST"
                    />
                </Modal>
                <Modal show={edit}>
                    <SponsorModal
                        getOrganizer={getOrganizer}
                        close={setEdit}
                        method="PUT"
                        id={editIdOrganize}
                    />
                </Modal>
                <MainPagination
                    pagination={pagination}
                    setPagination={setPagination}
                    data={organizer?.results}
                    pageSize={organizer?.page_count}
                    className=" mt-[3rem]"
                />
            </div>
        </div>
    );
};

export default Message;
